import type { CreateItemInput, Item, Samenvoeging } from '@boodschappenlijst/shared';
import { api } from '../../lib/apiClient';

export interface ItemMetSamenvoegingen extends Item {
  samenvoegingen: Samenvoeging[];
}

/** Een eerder gebruikte productnaam plus hoe vaak hij voorkwam. */
export interface Suggestie {
  naam: string;
  eenheid: string;
  keer: number;
  /** Extra woorden waarop deze suggestie te vinden is, naast de naam zelf.
   *  Komt alleen uit de AH-catalogus; eerder getypte namen hebben ze niet. */
  zoektermen?: string[];
}

export const itemsApi = {
  list: () => api.get<{ items: ItemMetSamenvoegingen[] }>('/items'),
  /** Vraagt of dit product al openstaat, zodat we kunnen aanbieden het samen te
   *  voegen in plaats van een tweede regel te maken. */
  check: (naam: string) =>
    api.get<{ matches: Item[] }>(`/items/check?naam=${encodeURIComponent(naam)}`),
  create: (input: CreateItemInput) => api.post<{ item: Item }>('/items', input),
  toggleGedaan: (id: string) => api.patch<{ item: Item }>(`/items/${id}/gedaan`),
  samenvoegen: (id: string, aantal: number) =>
    api.patch<{ item: Item }>(`/items/${id}/samenvoegen`, { aantal }),
  remove: (id: string) => api.del<{ ok: true }>(`/items/${id}`),
  removeGedaan: () => api.del<{ verwijderd: number }>('/items/gedaan'),
  /** Eerder gebruikte namen, vaakst gebruikte eerst. */
  suggesties: () => api.get<{ suggesties: Suggestie[] }>('/items/suggesties'),
  archief: () => api.get<{ items: Item[] }>('/items/archief'),
};
